import React, { useState } from 'react';
import WebInput from '../../../component/library/webInput';
import WebButton from '../../../component/library/webButton';
import { FcGoogle } from 'react-icons/fc';
import content from '../../../helper/content/login.json';
import { useDispatch } from 'react-redux';
import { useLoader } from '../../../base/context/LoaderProvider';
import { ToastTypes, useMessage } from '../../../base/context/MessageProvider';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthApiService } from '../../../service/authApiService';
import { emailRegex } from '../../../helper/regex';
import { addItems } from '../../../redux/slices/sidebarSlice';
import { adminSidebarArray, sellerSidebarArray } from '../../../helper/utils';
import { setAuthLocalStorage } from '../../../storage/localStorage';
import { useGoogleLogin } from '@react-oauth/google';
import loginAnimation from '../../../assets/lotties/login.json';
import Lottie from 'react-lottie';
// import Navbar from '../../../component/common/authNavbar';
import WebNavbar from '../../../website/component/layout/navbar';
import { FiEye, FiEyeOff } from 'react-icons/fi';

import './style.css';

const defaultLottieVideoOptions = {
  loop: true,
  autoplay: true,
  animationData: loginAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export default function Login() {
  const navigate = useNavigate();
  const message = useMessage();
  const loader = useLoader();
  const dispatch = useDispatch();
  const location = useLocation(); 
  const [data, setData] = useState({
    email: '',
    password: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const [error, setError] = useState({
    email: '',
    password: '',
  });

  const handleOnchange = e => {
    console.log('email df  ', e.target.value)
    setData({ ...data, [e.target.name]: e.target.value });
    setError({ ...error, [e.target.name]: '' });
  };

  const validate = () => {
    let result = true;
    if (!data.email.length) {
      setError({ ...error, email: 'Email is required' });
      result = false;
    } else if (!data.email.match(emailRegex)) {
      setError({ ...error, email: 'Not a valid email address' });
      result = false;
    } else if (!data.password.length) {
      setError({ ...error, password: 'Password is required' });
      result = false;
    }
    return result;
  };

  const getRedirectTarget = () => {
    // 1) state.from from router
    const fromState = location?.state?.from;
    const from =
      (fromState &&
        `${fromState.pathname || ""}${fromState.search || ""}${fromState.hash || ""}`) ||
      null;
    // 2) sessionStorage fallback
    const fromSS = sessionStorage.getItem("postAuthRedirect");
    const target = from || fromSS || "";
    
    if (!target || target.startsWith("/login") || target.startsWith("/signup")) return null;
    return target;
  };

  const goAfterAuth = (roleFallback) => {
    const to = getRedirectTarget();
    sessionStorage.removeItem("postAuthRedirect");
    if (to) return navigate(to, { replace: true });
    
    if (roleFallback === 'seller') return navigate('/', { replace: true });
    if (roleFallback === 'admin' || roleFallback === 'sub-admin') return navigate('/admin/dashboard', { replace: true });
    return navigate('/', { replace: true });
  };

  

  const handleUpdateSidebar = (type, assignedMenus = []) => {
    if (type === 'seller') {
      // Sellers get their default menus PLUS any assigned admin menus from roles
      let finalSidebar = [...sellerSidebarArray];
      
      // If seller has assigned role permissions, add those admin menus
      if (assignedMenus && assignedMenus.length > 0) {
        const allowedMenuKeys = assignedMenus
          .filter(m => m.canView)
          .map(m => m.menuKey);
        const allowedLinks = assignedMenus
          .filter(m => m.canView)
          .map(m => m.menuLink);
        
        const filteredAdminMenus = adminSidebarArray.filter(item => {
          // Check by menuKey match (e.g., 'products' matches sidebar item name)
          const itemKey = item.name?.toLowerCase().replace(/\s+/g, '-');
          if (allowedMenuKeys.some(key => key === itemKey || itemKey?.includes(key) || key?.includes(itemKey))) {
            return true;
          }
          // Check if main link is allowed (exact or partial match)
          if (allowedLinks.some(link => {
            if (item.link && item.link === link) return true;
            if (item.tabLink && item.tabLink === link) return true;
            // Partial match for parent menus (e.g., /admin/products matches /admin/products/list)
            if (item.tabLink && link && item.tabLink.startsWith(link)) return true;
            if (item.link && link && item.link.startsWith(link)) return true;
            return false;
          })) {
            return true;
          }
          // Check if any sub-item link is allowed
          if (item.items && item.items.length > 0) {
            return item.items.some(subItem => allowedLinks.some(link => {
              if (subItem.link === link) return true;
              if (subItem.link && link && subItem.link.startsWith(link)) return true;
              return false;
            }));
          }
          return false;
        });
        
        // Merge seller default menus with assigned admin menus
        if (filteredAdminMenus.length > 0) {
          finalSidebar = [...sellerSidebarArray, ...filteredAdminMenus];
        }
      }
      
      dispatch(addItems(finalSidebar));
    } else if (type === 'admin') {
      // Full admin - show ALL menus without any filtering
      dispatch(addItems(adminSidebarArray));
    } else if (type === 'sub-admin') {
      // For sub-admin only, filter sidebar based on assigned menus
      if (assignedMenus && assignedMenus.length > 0) {
        const allowedMenuKeys = assignedMenus
          .filter(m => m.canView)
          .map(m => m.menuKey);
        const allowedLinks = assignedMenus
          .filter(m => m.canView)
          .map(m => m.menuLink);
        
        const filteredSidebar = adminSidebarArray.filter(item => {
          // Check by menuKey match (e.g., 'products' matches sidebar item name)
          const itemKey = item.name?.toLowerCase().replace(/\s+/g, '-');
          if (allowedMenuKeys.some(key => key === itemKey || itemKey?.includes(key) || key?.includes(itemKey))) {
            return true;
          }
          // Check if main link is allowed (exact or partial match)
          if (allowedLinks.some(link => {
            if (item.link && item.link === link) return true;
            if (item.tabLink && item.tabLink === link) return true;
            // Partial match for parent menus (e.g., /admin/products matches /admin/products/list)
            if (item.tabLink && link && item.tabLink.startsWith(link)) return true;
            if (item.link && link && item.link.startsWith(link)) return true;
            return false;
          })) {
            return true;
          }
          // Check if any sub-item link is allowed
          if (item.items && item.items.length > 0) {
            return item.items.some(subItem => allowedLinks.some(link => {
              if (subItem.link === link) return true;
              if (subItem.link && link && subItem.link.startsWith(link)) return true;
              return false;
            }));
          }
          return false;
        });
        
        dispatch(addItems(filteredSidebar.length > 0 ? filteredSidebar : adminSidebarArray));
      } else {
        // No assigned menus - show all (fallback)
        dispatch(addItems(adminSidebarArray));
      }
    }
  };

  const handleLogin = e => {
    e.preventDefault();
    if (validate()) {
      const payload = {
        ...data,
        email: data.email ? data.email.toLowerCase().trim() : data.email,
      };  
      setIsLoggingIn(true);
      loader.showLoading(true);
      AuthApiService.login(JSON.stringify(payload))
        .then(async res => {
          loader.showLoading(false);
          if (res.status.code === 200) {
            await handleUpdateSidebar(res.data.role, res.data.assignedMenus);
            const data = {
              loginHeader: res.data.token,
              userType: res.data.role,
              assignedMenus: res.data.assignedMenus || [],
              isAffiliate: res.data.isAffiliate === true,
              isSeller: res.data.isSeller !== false,
            };

            // Clear old assignedMenus before setting new ones
            localStorage.removeItem('assignedMenus');
            
            setAuthLocalStorage(data);
            // Store assigned menus in localStorage for sidebar filtering
            if (res.data.assignedMenus) {
              localStorage.setItem('assignedMenus', JSON.stringify(res.data.assignedMenus));
            }
            // Also store userType in lowercase for consistency
            localStorage.setItem('userType', res.data.role);
            
            // Reset PDP open count and search count on successful login
            localStorage.removeItem('userPdpOpenCount');
            localStorage.removeItem('userSearchCount');
            // if (res.data.role === 'seller') {
            //   navigate('/seller/dashboard');
            // } else if (res.data.role === 'admin') {
            //   navigate('/admin/dashboard');
            // }
             goAfterAuth(res.data.role); 
          } else {
            message.showToast(res.error.message, ToastTypes.ERROR);
          }
        })
        .catch(err => {
          message.showToast(err?.message || 'Server error. Try again later', ToastTypes.ERROR);
          loader.showLoading(false);
        })
        .finally(() => {
          setIsLoggingIn(false);
        });
    }
  };

  const handleCreateAccount = async () => {
    navigate('/signup');
  };

  const handleForgetPassword = () => {
    navigate('/login/forgetPassword/verifyEmail');
  };

  const login = e => {
    e.stopPropagation();
    loginWithGoogle();
  };

  const loginWithGoogle = useGoogleLogin({
     // ensure we can read full basic profile
    scope: 'openid email profile',
    onSuccess: tokenResponse => {
      const authPayload = {
        accessToken: tokenResponse.access_token,
      };

      loader.showLoading(true);
      AuthApiService.googleLogin(JSON.stringify(authPayload))
        .then(async res => {
          loader.showLoading(false);
          if (res.status.code === 200) {
            await handleUpdateSidebar(res.data.role);
            const data = {
              loginHeader: res.data.token,
              userType: res.data.role,
              isAffiliate: res.data.isAffiliate === true,
              isSeller: res.data.isSeller !== false,
            };
            setAuthLocalStorage(data);
            // if (res.data.role === 'seller') {
            //   navigate('/seller/profile');
            // }
              goAfterAuth(res.data.role); 
            message.showToast('Login Successfully', ToastTypes.SUCCESS);
          } else {
            // DON'T SHOW TOAST FOR LOGIN ERROR, DIRECTLY REDIRECT TO LOGIN PAGE
            // message.showToast(res.error.message, ToastTypes.ERROR);
            navigate('/login', { replace: true });
          }
        })
        .catch(err => {
          message.showToast(err?.message || 'Server error. Try again later', ToastTypes.ERROR);
          loader.showLoading(false);
        });
    },
    onError: err => {
      console.log('Login Failed', err);
    },
  });

  return (
    <div>
      {/* <Navbar /> */}
       <WebNavbar authPage={true} />
      <div className="auth_container">
        <div className="auth_row">
          <div className="auth_col_one">
            <h1 className="auth_heading">
              {content.upsaleoHeading}
              <br />
              {content.upsaleoSubHeading}
            </h1>

            <div>
              <Lottie className="auth_image" options={defaultLottieVideoOptions} height={500} width={500} />
            </div>
          </div>

          <div className="auth_col_two login_auth_col_two">
            <form className="auth_form" onSubmit={e => handleLogin(e)}>
              <h1>{content.mainHeading}</h1>
              <h3>{content.subHeading}</h3>
              {/* Email (floating label) */}
              <div className={`float_group ${error.email ? "has-error" : ""}`}>
                <WebInput
                  parentClassName="input_parent"
                  className="login_input"
                  id="loginEmail"
                  type="email"
                  placeholder=" "
                  name="email"
                  value={data.email}
                  error={error.email}
                  onChange={handleOnchange}
                />
                <label htmlFor="loginEmail" className="float_label">Email</label>
              </div>

              {/* Password (floating label) */}
              <div className={`float_group ${error.password ? "has-error" : ""} password_group`}>
                <WebInput
                  parentClassName="input_parent"
                  className="login_input"
                  id="loginPass"
                  type={showPassword ? "text" : "password"}
                  placeholder=" "
                  name="password"
                  value={data.password}
                  error={error.password}
                  onChange={handleOnchange}
                />
                <label htmlFor="loginPass" className="float_label">Password</label>

                <button
                  type="button"
                  className="eye_btn"
                  onClick={() => setShowPassword(p => !p)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                </button>
              </div>

              <h2 onClick={() => handleForgetPassword()}>{content.forgetPassword}</h2>
              <WebButton
                className={`login_auth_btn ${isLoggingIn ? "disabled_btn" : ""}`}
                text={isLoggingIn ? "Logging in..." : "Log in"}
                type="submit"
                disabled={isLoggingIn}
              />
              {/* Hide For Now  */}
              {/* <div className="continue_msg">
                <span></span>or continue with<span></span>
              </div>

              <button className="auth_google_btn" onClick={e => login(e)} type="button">
                <FcGoogle size={20} />
                {content.googleLogin}
              </button> */}

              <div className="auth_message">
                <p>{content.signUpMessage}</p>
                <p onClick={() => handleCreateAccount()}>{content.signUpText}</p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
